export default "__VITE_ASSET__BXLViTwn__"